/**
 * MainLayout — persistent shell for all content routes.
 *
 * Client: Renders Header + Outlet + Footer so they stay mounted across
 * client-side navigations (no unmount/remount flash).
 *
 * SSR: Accepts `children` prop as fallback (no Router context on server),
 * keeping the rendered tree identical for hydration.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header/Header.mjs';
import Footer from '../components/footer/Footer.mjs';

export default function MainLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <div className="flex-1 page-backdrop">
                {children || <Outlet />}
            </div>
            <Footer />
        </div>
    );
}
